<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    v-bind:title="title"
    class="!max-w-[720px]">
    <template v-slot:modalBody>
      <div class="flex flex-col gap-[8px] pb-[12px]">
        <div v-if="props.description">{{ props.description }}</div>
        <div
          v-for="(file, index) in props.files"
          v-bind:key="`file-${index}`"
          class="self-stretch">
          <refonte-label v-bind:label="file.formation" />
          <refonte-item-file-convention-line
            v-bind:id="`convention-${index}`"
            v-bind:open_signature_manuelle="props.open_signature_manuelle"
            v-bind:title="file.title"
            v-bind:subtitle="file.subtitle"
            v-bind:convention="file"
            v-bind:on_submit="props.on_submit"
            v-bind:on_close="props.on_close"
            v-bind:participant_nom_prenom="props.participant_nom_prenom"
            v-bind:session_date="props.session_date"
            v-bind:formation_title="file.produitTitre"
            v-bind:client_id="props.client_id"
            v-bind:signature_manuelle="props.signature_manuelle" />
        </div>
      </div>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteLabel from '@/components/refonte/inputs/refonte-label.vue';
  import { ConventionDocument } from '@/types/gestion/inscriptions-types';
  import RefonteItemFileConventionLine from '@/components/refonte/items/refonte-item-file-convention-line.vue';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      on_submit?: Function;
      open_signature_manuelle?: Function;
      title?: string;
      files: ConventionDocument[];
      file_on_click_download?: Function;
      participant_nom_prenom?: string;
      session_date?: string;
      class?: string;
      description?: string;
      client_id: number;
      signature_manuelle?: boolean;
    }>(),
    {
      title: 'Convention(s)',
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
